// extracted by extract-css-chunks-webpack-plugin
module.exports = {"setExpressCheckout":"ULOZx","saveDefaultPayment":"oCC8i","setExpressCheckoutStyle":"GW2eT","setDefaultPaymentStyle":"Zi8ZO"};